import { gql } from "@apollo/client";
import { getClient } from "utils/client";

const INSERT_EXTENSION_VIEW = gql`
    mutation InsertExtensionView($contentid: uuid!, $userid: uuid) {
        insert_mix_content_view_one(
            object: {
                contentid: $contentid
                userid: $userid
                source: "extension"
            }
        ) {
            id
        }
    }
`;

/**
 * 크롬 익스텐션에서 콘텐츠 조회를 추적합니다
 *
 * @param contentid - 조회된 콘텐츠의 UUID
 * @param userid - 사용자 ID (게스트인 경우 null)
 */
export async function trackExtensionView(
    contentid: string,
    userid: string | null = null
) {
    try {
        const client = getClient({ ctx: null });

        await client.mutate({
            mutation: INSERT_EXTENSION_VIEW,
            variables: {
                contentid,
                userid
            }
        });

        console.log("[Extension] View tracked:", { contentid, userid });
    } catch (error) {
        console.error("[Extension] Failed to track view:", error);
    }
}
